<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="EBook-Break" id="_idParaDest-5"> </p>
<p class="BT1stPara ParaOverride-1">And much of Madness, and more of Sin,<br/>And Horror the soul of the plot.</p>
<p class="BT1stPara ParaOverride-1">—Edgar Allan Poe</p>
<p class="BT1stPara ParaOverride-9">New Orleans is a settlement of the dregs of the French bohème, in the truest sense of the word a French convict colony—and never, with the changes of time, has it belied its origin. </p>
<p class="BT1stPara ParaOverride-1"><span xml:lang="de-DE">—Karl Marx, </span><span class="CharOverride-2" xml:lang="de-DE">Die Presse</span><span xml:lang="de-DE">, May 20, 1862</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eBook43514.vue?0e14334a